import styled from 'styled-components';
import { Alert } from '@mui/material';
import colors from '../../../styles/colors';

const StyledAlert = styled(Alert)`
  background: ${colors.shades.beta2};
  color: ${colors.shades.primary1};
  min-height: 25px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0;
  div {
    padding: 0;
  }
  svg {
    height: 17px;
    color: ${colors.shades.primary1};
  }

`;

export { StyledAlert };
